<template>
  <div class="w-100">
    <multiselect
      v-model="selectValue"
      :multiple="false"
      :options="Object.keys(optionsList)"
      :custom-label="(val) => optionsList[val]"
      :show-labels="false"
      :placeholder="placeholder"
      aria-describedby="input-langs-feedback"
    />
  </div>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    optionsList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    selectValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    const element = this.$el.querySelector('.multiselect')
    element.style.setProperty('--bg-image', `url(${this.image})`)
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .multiselect {
      .multiselect__placeholder, input, .multiselect__single {
        padding-left: 1.75rem;
        background-repeat: no-repeat;
        background-position: left 0.1rem center;
        background-image: var(--bg-image);
      }
    }
  }
</style>
